const prod = {
    url: {
        SERVER_URL: window.location.origin,
        SERVER_API_URL:  window.location.origin + '/api'
    }
};
const dev = {
    url: {
        SERVER_URL: 'http://localhost:8080/',
        SERVER_API_URL: 'http://localhost:8080/api/'
    }
};
//module.exports.SERVER_API_URL = dev.url.SERVER_API_URL
export const config = process.env.NODE_ENV === 'development' ? dev : prod;